import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRightIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 20,
	height: 34.941,
	viewBox: "0 0 20 34.941",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_6",
				"data-name": "Rectangle 6",
				width: 20,
				height: 34.941
			})
		}) }),
		/* @__PURE__ */ _jsx("g", {
			id: "Group_414",
			"data-name": "Group 414",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Group_5",
				"data-name": "Group 5",
				clipPath: "url(#clip-path)",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Path_1",
					"data-name": "Path 1",
					d: "M.687.685a2.329,2.329,0,0,1,3.3,0L19.456,16.158a1.854,1.854,0,0,1,0,2.625L3.985,34.257a2.331,2.331,0,0,1-3.3-3.3l13.481-13.5L.67,3.962A2.319,2.319,0,0,1,.687.685",
					transform: "translate(-0.002 0)"
				})
			})
		})
	]
});
const ForwardRef = forwardRef(SvgRightIcon);
export default ForwardRef;
